var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-content flex flex-col-center flex-row-between"},[_c('span',{staticClass:"title-text",style:({'--distanceLeft': _vm.distanceLeft, '--beforeColor': _vm.beforeColor})},[_vm._v(_vm._s(_vm.title))]),(_vm.isShowLine)?_c('div',{staticClass:"line-title"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }